module.exports = __webpack_public_path__ + "static/media/6targets.4c1f9ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/6targets.png
// module id = 167
// module chunks = 0